import { render, staticRenderFns } from "./chemRule.vue?vue&type=template&id=27ac709c"
import script from "./chemRule.vue?vue&type=script&lang=js"
export * from "./chemRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27ac709c')) {
      api.createRecord('27ac709c', component.options)
    } else {
      api.reload('27ac709c', component.options)
    }
    module.hot.accept("./chemRule.vue?vue&type=template&id=27ac709c", function () {
      api.rerender('27ac709c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/chemRule.vue"
export default component.exports